import React from 'react'
import { connect } from 'react-redux'
import { fetchTop20IfNeeded, fetchTop20Counter } from '~/features/actions'
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { DateTime } from 'luxon';

class Top20 extends React.Component {

  constructor() {
    super();
    this.state = {
      data: [],
      pos: []
    }
    let h100Timeout = null
  }


  componentDidMount() {
    document.getElementsByTagName('body')[0].className = 'top20';

    const { match, history, dispatch } = this.props
    dispatch(fetchTop20IfNeeded())

    clearTimeout(this.nPTimeout)
    let _this = this

    function getNowPlaying(_this) {
      dispatch(fetchTop20Counter())
      _this.nPTimeout = setTimeout(getNowPlaying, 10000, _this)
    }
    _this.nPTimeout = setTimeout(getNowPlaying, 0, _this)
  }

  componentWillUnmount() {
    document.getElementsByTagName('body')[0].className = '';
    clearTimeout(this.nPTimeout)
  }

  componentDidUpdate() {
  }

  render() {
    //const { data, top20, pos } = this.state
    const { top20 } = this.props

    if (top20.items.length > 0 && top20.counter) {

      let part = top20.items.slice(top20.counter - 1)







      var cssHSL = "hsl(" + 360 * Math.random() + ',' +
                 (25 + 70 * Math.random()) + '%,' +
                 (85 + 10 * Math.random()) + '%)';
     var fgHSL = "hsl(" + 360 * Math.random() + ',' +
                (25 + 70 * Math.random()) + '%,' +
                (85 + 10 * Math.random()) + '%)';

      return (
        <div className="section group" style={{paddingTop: '64px', minHeight: '100vh', backgroundColor: cssHSL, color: fgHSL, transition: 'color 10000ms 0ms, background-color 10000ms 500ms'}}>
          THE CHART SHOW STARTS COUNTING DOWN FROM 6PM FRIDAY... THIS LIST MARKS THE WEEK ENDING {DateTime.fromISO(top20.field_top_list_date[0].value).plus({days: 7}).toFormat('D/M')}
        { part.map((item, index) => {
            return (
              <div className="item" key={index} style={{minHeight: '10vh', color: cssHSL, transition: 'color 10000ms 0ms'}}>
                <div className="listing">
                  <AnimationOnScroll animateIn="bounceIn" offset={0}>
                    <div className="number" style={{backgroundColor:  fgHSL, color: cssHSL, transition: 'color 10000ms 0ms, background-color 10000ms 500ms'}}>{item.pos}</div>
                  </AnimationOnScroll>
                  <AnimationOnScroll animateIn="slideInRight" offset={0} delay={200}>
                    <div className="artist" style={{textTransform: 'uppercase', color: fgHSL, transition: 'color 10000ms 0ms'}}>{item.artist}</div>
                  </AnimationOnScroll>
                  <AnimationOnScroll animateIn="flipIN" offset={0} delay={800}>
                    <div className="title" style={{color: fgHSL, transition: 'color 10000ms 0ms'}}>{item.title}</div>
                  </AnimationOnScroll>
                </div>
              </div>

            )
        })
        }
        </div>
      )
    } else {

    return (
      <div>TOP 20</div>
    )
    }
  }

}

export default connect(state => { return { top20: state.top20 }}) (Top20)
